
// This is an auto generated file - do not edit!
// Swagger path: /api/LogicStep/{logicStepCode}/parameter/{parameterCode}

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from '../base-api.service';
import {
    LogicStepFieldProperty, LogicStepSchema, SystemEntity
} from '@wdx/clmi/clmi-swagger-gen';
import { HttpParams } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class LogicstepLogicstepcodeParameterParametercodeApiService extends BaseApiService {
    
    post(logicStepCode: string, parameterCode: string, logicStepFieldProperty: LogicStepSchema, entityType?: SystemEntity, options = {}): Observable<LogicStepFieldProperty> {
        let params = new HttpParams();
        if(entityType !== undefined) {
            params = params.append('entityType', entityType);
        }

        return this._post<LogicStepFieldProperty, LogicStepSchema>(
            `/LogicStep/${logicStepCode}/parameter/${parameterCode}`,
            new LogicStepSchema(logicStepFieldProperty), {
                ...options,
                params,
            }
        );
    }
}
